import React, { createContext, useContext, useState } from "react";

// --- Logika Tahun Berjalan ---
const currentYear = new Date().getFullYear();

// Default periode: 01-01 s/d 31-12 tahun berjalan
const defaultPeriode = {
  startDate: `${currentYear}-01-01`,
  endDate: `${currentYear}-12-31`,
};
// -----------------------------

const PeriodeContext = createContext(null);

export const PeriodeProvider = ({ children }) => {
  const [periode, setPeriode] = useState(defaultPeriode);

  return (
    <PeriodeContext.Provider value={{ periode, setPeriode }}>
      {children}
    </PeriodeContext.Provider>
  );
};

export const usePeriode = () => {
  const context = useContext(PeriodeContext);
  if (!context) {
    throw new Error("usePeriode must be used within a PeriodeProvider");
  }
  return context;
};